<template>
  <div class="cart-summary">
    <!-- Cart Items -->
    <CartItem
      v-for="registration in registrationSession.registrations"
      :key="registration.id"
      :registration="registration"
      @remove-registration="$emit('remove-registration', $event)"
    />
    <!-- / Cart Items -->

    <!-- Cart Empty -->
    <div
      v-if="cartEmpty">
      <h4>Cart is empty.</h4>
    </div>
    <!-- / Cart Empty -->
  </div>
</template>

<script>
import AppMixin from '../services/mixin.app';
import CartItem from './CartItem.vue';

export default {
  name: 'cart-summary',
  components: { CartItem },
  mixins: [AppMixin],
};
</script>

<style lang="scss"></style>
